import { FC } from "react";
import {
  SanityLottie,
  SanityResponsiveImage,
  SanityVideoFile,
  SanityVideoYoutube,
} from "../../graphql-types";
import * as styles from "./BrandVisual.module.scss";
import Lottie from "./Lottie";
import ResponsiveImage from "./ResponsiveImage";
import VideoFileBlock from "./VideoFileBlock";
import VideoYoutubeBlock from "./VideoYoutubeBlock";

export interface BrandVisualProps {
  content:
    | SanityResponsiveImage
    | SanityVideoFile
    | SanityVideoYoutube
    | SanityLottie;
}

const BrandVisual: FC<BrandVisualProps> = ({ content }) => {
  return (
    <div className={styles.root}>
      {content._type === "videoYoutube" && (
        <VideoYoutubeBlock value={content} />
      )}
      {content._type === "videoFile" && <VideoFileBlock value={content} />}
      {content._type === "responsiveImage" && (
        // @ts-ignore
        <ResponsiveImage content={content} fullQuality />
      )}
      {content._type === "lottie" && <Lottie content={content} />}
    </div>
  );
};

export default BrandVisual;
